import React, { useState, useEffect } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import ModalActualizarUsuario from "./modalActualizarUsuario";
import axios from "axios";
import { Loader, Dimmer } from "semantic-ui-react";
import { CambiarClave } from "./modalCambiarClave";
import { Mensaje } from "../mensajes";

const headCells = [
  {
    id: "1",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "ID USUARIO",
    textAlign: "center",
  },
  {
    id: "2",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "USUARIO",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: " OPCIONES",
    textAlign: "center",
  },
];

function TablaUsuarios(props) {
  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [idUsuarioH, setIdUsuarioH] = useState(0);
  const [contarRet, setContarRet] = useState(0);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [usuarioH, setUsuarioH] = useState();
  const [persona, setPersona] = useState();
  const [configCome, setConfigCome] = useState();
  const [usuariow, setUsuariow] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [usupermi, setUsupermi] = useState("0000");
  const [retencion, setRetencion] = useState();
  const [espiritu, setEspiritu] = useState(sessionStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    sessionStorage.getItem("fechasistema")
  );
  const [anioActu, setAnioActu] = useState(sessionStorage.getItem("anioactu"));
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [permiso, setPermiso] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let contac = 0;

  let op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  let idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
  let idusuario = JSON.parse(sessionStorage.getItem("idusuario"));

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idusuario.includes(target.value) ||
              x.login.toLowerCase().includes(target.value.toLowerCase()) ||
              (x.nombres + " " + x.apellidos)
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  useEffect(() => {
    let obj = JSON.parse(sessionStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    setIdUsuario(obj.idusuario);
    setEspiritu(obj.espiritu);
    seleccionarRegistros();
  }, []);

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "usuarioweb";
    let nomid = "idorganizacion";
    let orden = "idusuario";
    let endpoint = "";

    if (props.menu === "sistema") {
      endpoint = `${op.conexion}/api/athos/consulta/seleccionarregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    }
    if (props.menu === "organizacion") {
      endpoint = `${op.conexion}/api/athos/consulta/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idorganizacion}`;
    }

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {          
            setRecords(response.data);
            SelectUsuarioDos(idusuario);         
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const SelectUsuarioDos = (idusuario) => {
    let endpoint = `${op.conexion}/api/athos/usuario/getuser?id=${idusuario}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idusuario > 0) {
            setUsupermi(response.data.accopuser);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "Error al cargar el usuario",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectUsuario = (idusuario) => {
    let endpoint = `${op.conexion}/api/athos/usuario/getuser?id=${idusuario}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idusuario > 0) {
            setPersona({
              cedula: response.data.cedula,
              nombres: response.data.nombres,
              apellidos: response.data.apellidos,
              correoe: response.data.correoe,
              tlf1: response.data.tlf1,
              tlf2: response.data.tlf2,
              fnacimiento: response.data.fnacimiento,
              nacionalidad: response.data.nacionalidad,
              sexo: response.data.sexo,
              direccion: response.data.direccion,
              nombreorg: response.data.nombreorg,
              idorganizacion: response.data.idorganizacion,
            });
            setUsuarioH(response.data);          
            setMostrar(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "Error al cargar el usuario",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const gestionarUsuarios = (id, op) => (e) => {
    e.preventDefault();
    setOperacion(op);

    if (op === 1) {
      setUsuarioH();
      setUsuariow();
      setPersona();
      setDeshabilitado(false);
      setMostrar(true);
    } else if (op === 2) {
      setDeshabilitado(false);
      setOperacion(2);
      setIdUsuarioH(id);
      setActivate(true);
      SelectUsuario(id);
    } else if (op === 3) {
      if (idUsuario === id) {
        setMensaje({
          mostrar: true,
          titulo: "Notificacion",
          texto: "El Usuario no se puede eliminar porque esta logueado",
          icono: "informacion",
        });
        return;
      }
      setDeshabilitado(true);
      setOperacion(3);
      setIdUsuarioH(id);
      setActivate(true);
      SelectUsuario(id);
    } else if (op === 4) {
      setDeshabilitado(true);
      setOperacion(4);
      setIdUsuarioH(id);
      setActivate(true);
      SelectUsuario(id);
    }
  };

  const cerrarModalActualizar = () => {
    setUsuarioH();
    setUsuariow();
    setPersona();
    setMostrar(false);
    seleccionarRegistros();
  };

  const validarActuUsuario = () => {
    if (operacion === 4) {
      setUsuarioH();
      setMostrar(false);
      return;
    }
    if (operacion === 1) {
      setIdUsuarioH(0);
    }
    setUsuarioH();
    setUsuariow();
    setPersona();
    setMostrar(false);
    seleccionarRegistros();
  };

  const cambiarClave = () => {
    setMostrar2(true);
  };

  const handleCloseClave = () => {
    setMostrar2(false);
  };

  return (
    <div className="container-fluid rounded">
      <div className="container-fluid w-100 h-100">
        <div className="card">
          <ModalActualizarUsuario
            show={mostrar}
            onHideCancela={cerrarModalActualizar}
            onHideAcepta={validarActuUsuario}
            usuario={usuarioH}
            datospersonales={persona}
            deshabilitado={deshabilitado ? deshabilitado : undefined}
            ingresa={0}
            declaweb={configCome ? configCome[0].declaweb.toString() : "false"}
            idusuario={idUsuario}
            operacion={operacion}
            menu={props.menu}
          />

          <CambiarClave show={mostrar2} onHide={handleCloseClave} />

          <div className="container">
            <div className="content">
              <div className="container">
                <div className="col-md-12 row m-0 py-2">
                  <div className="col-md-2">
                    <input
                      type="text"
                      className="form-control form-control-sm rounded-pill"
                      onChange={handleSearch}
                      placeholder="Buscar"
                    />
                  </div>

                  <div className="col-md-3 ml-auto">
                    {/*                                 <button disabled={permiso && permiso.substring(1, 2) !== "1" && permiso.substring(2, 3) !== "1"} onClick={cambiarClave} style={{ marginBottom: "10px" }} className="btn btn-primary btn-sm rounded-pill"><i className="fas fa-key"> Cambiar Clave</i> </button>
                     */}{" "}
                  </div>
                  <div className="col-md-1 ml-auto">
                    {usupermi && usupermi.toString().substring(1, 2) === "1" ? <button
                      onClick={gestionarUsuarios("", 1)}
                      className="btn btn-sm btn-primary rounded-circle"
                    >
                      <i className="fas fa-plus"></i>{" "}
                    </button> : ''}  
                  </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }}>
                  <TblContainer>
                    <TblHead />

                    <TableBody>
                      {records &&
                        recordsAfterPagingAndSorting().map((item, index) => (
                          <TableRow key={index} style={{ padding: "0" }}>
                            <TableCell
                              className="align-baseline"
                              style={{ textAlign: "center", width: "50px" }}
                            >
                              {item.idusuario}
                            </TableCell>
                            <TableCell
                              className="align-baseline"
                              style={{ textAlign: "left", width: "250px" }}
                            >
                              {item.login}
                            </TableCell>
                            <TableCell
                              className="align-baseline"
                              style={{ textAlign: "center", width: "100px" }}
                            >
                              {usupermi && usupermi.toString().substring(0, 1) === "1" ? <button
                                onClick={gestionarUsuarios(item.idusuario, 4)}
                                className="btn btn-sm  btn-info rounded-circle ml-2"
                              >
                                <i className="fas fa-eye"></i>{" "}
                              </button> : ''}
                              
                              {usupermi && usupermi.toString().substring(2, 3) === "1" ? <button
                                onClick={gestionarUsuarios(item.idusuario, 2)}
                                className="btn btn-sm  btn-warning rounded-circle ml-2"
                              >
                                <i className="fa fa-edit"></i>{" "}
                              </button> : '' } { usupermi && usupermi.toString().substring(3, 4) === "1" ? <button
                                onClick={gestionarUsuarios(item.idusuario, 3)}
                                className="btn btn-sm  btn-danger rounded-circle ml-2"
                              >
                                <i className="fa fa-trash"></i>{" "}
                              </button> : ''}
                                                                            
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </div>
              </div>
            </div>
          </div>
          <Dimmer active={activate} inverted>
            <Loader inverted>cargando...</Loader>
          </Dimmer>
          <Mensaje
            mensaje={mensaje}
            onHide={() => {
              setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default TablaUsuarios;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/tablaUsurios.js